import {
  ICICI_LOMBARD,
  IFFCO_TOKIO,
  BAJAJ,
  RELIANCE,
  SBI,
  BHARTI_AXA,
  CHOLA_MS,
  NATIONAL,
  TATA_AIG,
  NEW_INDIA,
  UNIVERSAL_SOMPO,
  HDFC_ERGO,
  UNITED_INDIA,
  FUTURE_GENERALI,
  LNT,
  LIBERTY,
  ROYAL_SUNDARAM,
  ORIENTAL_INSURANCE,
  SHRIRAM,
  DIGIT,
  CARE,
  NIVA_BUPA_MAX,
  STAR_HEALTH,
  ADITYA_BIRLA,
} from './constants';

export const insurers = [
  ICICI_LOMBARD,
  DIGIT,
  HDFC_ERGO,
  NEW_INDIA,
  IFFCO_TOKIO,
  BAJAJ,
  RELIANCE,
  SBI,
  BHARTI_AXA,
  CHOLA_MS,
  NATIONAL,
  TATA_AIG,
  UNIVERSAL_SOMPO,
  UNITED_INDIA,
  FUTURE_GENERALI,
  LNT,
  ADITYA_BIRLA,
  STAR_HEALTH,
  NIVA_BUPA_MAX,
  CARE,
  SHRIRAM,
  LIBERTY,
  ROYAL_SUNDARAM,
  ORIENTAL_INSURANCE,
];
